export default __webpack_public_path__ + "static/media/p1_optimal4.26b46ed8.png";